export interface PurchaseRefundStatus {
    bookingReference: string;
    journeys: Journey[];
    adminFeeCharged: number;
    balance: number;
    purchaseTime: Date;
    isFeeFree: number;
}

export interface RefundReasonObject {
    code: string;
    name: string;
}

export interface Journey {
    journeyID: string;
    isScannedBool: boolean;
    isScanned: number;
    isPrinted: number;
    isPrintedBool: boolean;
    isCancelled: number;
    isCancelledBool: boolean;
    isAdvance: number;
    isAdvanceBool: boolean;
    adminFee: number;
    adminFeeReplacement: number;
    balance: number;
    ticketsRefundValue: number;
    ticketsReplaceValue: number;
    deliveryMethodCode: string;
    tickets: Ticket[];
    refundOptions: RefundOptions;
}

export interface RefundCodeAndScopes {
    reasonCode: string;
    permitted: boolean;
    permitTicketSubset: boolean;
    permitBookingFeeRefund: boolean;
    permitShareOfSavingRefund: boolean;
    scopes: RefundScope[];
}

export interface RefundScopeTicketSubset {
    ticketReference: string,
    cancelValuePence: string
}

export interface RefundScope {
    scope: JourneyScopeEnum,
    maxRefundAmountPence: number,
    permitted: boolean,
    notPermittedIndex: number,
    selfRefundPermitted: boolean,
    tickets: RefundScopeTicketSubset[]
}

export enum JourneyScopeEnum {
    All = "All",
    In = "In",
    Out = "Out"
}

export interface RefundOptions {
    notPermittedReasons: string[];
    refundCodes: RefundCodeAndScopes[];
}

export interface Ticket {
    ticketReference: string;

    // Both NLCs
    origin: string;
    destination: string;

    ticketCode: string;
    routeCode: string;
    isAdvanceBool: boolean;
    isScannedBool: boolean;
    isPrintedBool: boolean;
    isCancelledBool: boolean;

    railcard: string;
    numChildren: number;
    numAdults: number;

    journeyScope: JourneyScopeEnum;
}
